module.exports = __webpack_public_path__ + "6f555e8cc9e304d39d8e8dce957966a6.png";


//////////////////
// WEBPACK FOOTER
// ../server/public/static/images/moma/nav-light-left@2x.png
// module id = 299
// module chunks = 0 1 2 3 4 5